import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../Screens/auth/Login";
import PageNotFound from "../Screens/auth/PageNotFound";
import Header from "../Screens/drawer/Header";
// import Dashboard from "../Screens/drawer/Dashboard";
import AddProject from "../Screens/taps/AddProject";
import ViewProjcts from "../Screens/taps/ViewProjcts";
import ViewMeetings from "../Screens/taps/ViewMeeting";
// import AddTicket from "../Screens/ticketSystem/addTicket";
// import ViewTicket from "../Screens/ticketSystem/viewTicket";

export const Routing = () => {
  return (
    <Routes>
      <Route path="/" exact element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/404/page-not-found" element={<PageNotFound />} />
      {window.localStorage.getItem("isAuthenticated") === "true" && (
        <Route path="/main" element={<Header />}>
          {/* <Route index element={<Dashboard />} /> */}
          <Route path="/main/add-project" element={<AddProject />} />
          <Route path="/main/view-project" element={<ViewProjcts />} />
          <Route path="/main/meeting-list" element={<ViewMeetings />} />
          {/* <Route path="/main/add-ticket" element={<AddTicket />} /> */}
          {/* <Route path="/main/view-ticket" element={<ViewTicket />} /> */}
        </Route>
      )}
      <Route path="*" element={<Navigate to="/404/page-not-found" replace />} />
    </Routes>
  );
};
